module.exports = __webpack_public_path__ + "img/saomiaoqiang.3296feaf.png";